import { IProjection } from '@opengov/reporting-types';
import { GroupByConfig } from '../../../src/components/editor/sidepanel/columnEditor/ColumnEditorTypes';

export function buildGroupingProjection(groupByConfig: GroupByConfig): IProjection {
  switch (groupByConfig.variant) {
    case 'multi-hierarchy':
      return {
        groupId: groupByConfig.groupId,
        segmentId: groupByConfig.segmentId
      };
    case 'multi-hierarchy-account-number':
      return {
        groupId: groupByConfig.groupId,
        segmentId: groupByConfig.segmentId,
        accountNumber: true
      };
    case 'dimension': {
      const [joinColumnName, groupByColumn] = groupByConfig.groupBy.split(':');

      if (groupByConfig.groupByDimensionId) {
        return {
          columnName: groupByColumn,
          dimension: { id: groupByConfig.groupByDimensionId },
          joinColumnName
        };
      }

      // when groupByColumnName isn't compound so joinColumnName is actually the groupByColumn
      return { columnName: joinColumnName };
    }
    default: {
      const _exhaustiveCheck: never = groupByConfig;
      throw new Error(`Unknown groupByConfig variant: ${JSON.stringify(_exhaustiveCheck)}`);
    }
  }
}
